import React, { Component } from "react";
import Navbar from "../../bars/Navbar";
import Sidebar from "../../bars/Sidebar";
import Logo from "../../img/logo512.png";

export default class ErrorBoard extends Component {
  
  render() {
    document.title = "Error 404 Página No Encontrada";
    return (
      <>
        <div className="flex">
          <Sidebar />
          <div className="content w-100 cont">
            <Navbar />
            <img
            src={Logo}
            alt="SIDEC"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "500px", // o un valor razonable
              display: "block",
              margin: "0 auto",
            }}
          />
            <h1 className="text-center">
              <b>ERROR 404: PÁGINA NO ENCONTRADA</b>
            </h1>
            <p className="text-center"><a href="/home">Volver</a></p>
          </div>
        </div>
      </>
    );
  }
}
